import { render, staticRenderFns } from "./ReportViewDetailContratoCuerpoTecnico.vue?vue&type=template&id=27b0baa7&scoped=true&"
import script from "./ReportViewDetailContratoCuerpoTecnico.vue?vue&type=script&lang=js&"
export * from "./ReportViewDetailContratoCuerpoTecnico.vue?vue&type=script&lang=js&"
import style0 from "./ReportViewDetailContratoCuerpoTecnico.vue?vue&type=style&index=0&id=27b0baa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0baa7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VSnackbar,
  VTooltip,
})
